/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `V místě vyzvednutí`
};

const da_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `Ved afhentningssted`
};

const de_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `An einer Abholstation`
};

const en_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `At a pickup point`
};

const es_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `En punto de recogida`
};

const fr_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `En point relais`
};

const hu_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `Felvételi ponton`
};

const it_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `In punto di ritiro`
};

const nl_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `Bij een afhaalpunt`
};

const pl_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `Punkt odbioru`
};

const pt_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `Em ponto de retirada`
};

const sv_at_a_pickup_point = /** @type {(inputs: {}) => string} */ () => {
	return `På utlämningsställe`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const at_a_pickup_point = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.at_a_pickup_point(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("at_a_pickup_point", locale)
	if (locale === "cs") return cs_at_a_pickup_point(inputs)
	if (locale === "da") return da_at_a_pickup_point(inputs)
	if (locale === "de") return de_at_a_pickup_point(inputs)
	if (locale === "en") return en_at_a_pickup_point(inputs)
	if (locale === "es") return es_at_a_pickup_point(inputs)
	if (locale === "fr") return fr_at_a_pickup_point(inputs)
	if (locale === "hu") return hu_at_a_pickup_point(inputs)
	if (locale === "it") return it_at_a_pickup_point(inputs)
	if (locale === "nl") return nl_at_a_pickup_point(inputs)
	if (locale === "pl") return pl_at_a_pickup_point(inputs)
	if (locale === "pt") return pt_at_a_pickup_point(inputs)
	return sv_at_a_pickup_point(inputs)
};